// extracted by mini-css-extract-plugin
export default {"sortPanel":"SortPanel_sortPanel__T8-FH","sortPanelText":"SortPanel_sortPanelText__pcrEL"};